import React, { useEffect, useState } from "react";
import { FaWhatsapp, FaFire } from "react-icons/fa";
import { BiPhoneCall } from "react-icons/bi";
import { IoMailOpenOutline } from "react-icons/io5";
import { FaTrashAlt, FaCheckCircle } from "react-icons/fa";
import { RiSaveFill } from "react-icons/ri";
import { AiFillQuestionCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Product_Details from "../Product_Details_Component/Product_Details";
import StatusDropdown from "../Component/Select_Component/StatusDropdown";
import Product_Owner_Edit_Form from "./Product_Details_Edit_SubComponent/Product_Owner_Edit_Form";

function Add_Produc_Edit() {
  const [showModal, setShowModal] = useState(false);
  const [showModalSave, setShowModalSave] = useState(false);
  const [activeTab, setActiveTab] = useState("details");

  const Nav = useNavigate();
  const handledelete = () => {
    setShowModal(false);
    // Nav("/admin-dashboard/view-buyer/");
  };
  const handleSubmit = async () => {
    // console.log(formData);
    setShowModalSave(false);
    // Nav("/admin-dashboard/view-buyer/");
  };
  return (
    <div>
      <div className="border-2 border-gray-200   rounded-2xl p-5 w-[80vw]">
        <div className="border-b  pb-2 flex justify-between  items-center py-4 ">
          <h1 className="text-xl text-gray-600 font-semibold">Edit Product</h1>
          <div className="flex items-center gap-1.5">
            {/* WhatsApp Button */}
            <button className="flex gap-2 items-center bg-[#25d366] text-white px-4 py-2 rounded-md">
              <FaWhatsapp /> WhatsApp
            </button>

            {/* Call Button */}
            <button className="flex gap-2 items-center bg-[#333333] text-white px-6 py-2 rounded-md">
              <BiPhoneCall /> Call
            </button>

            {/* Send Email Button */}
            <div className="flex items-center overflow-hidden rounded-md border border-oceanBlue text-oceanBlue">
              <span className="bg-oceanBlue p-2 text-white text-xl">
                <IoMailOpenOutline />
              </span>
              <button className="px-3 py-1">Send Email</button>
            </div>

            {/* 🔥 Trending Products Button */}
            <button className="flex gap-2 items-center border border-orange-500 text-orange-500 px-4 py-1.5 rounded-md hover:bg-orange-50">
              <FaFire className="text-orange-500" />
              Trending Products
            </button>
          </div>
          <div>
            <div className="flex gap-2">
              <button
                className="bg-green-500 border border-b-back-950 text-white p-2 text-xl rounded-md"
                onClick={() => Nav("/admin-dashboard/save-product")}
              >
                <RiSaveFill className="text-white" />
              </button>

              <button
                onClick={() => setShowModal(true)}
                className="bg-blood p-2 rounded-md text-white text-xl"
              >
                {" "}
                <FaTrashAlt />
              </button>
            </div>
          </div>
        </div>
        {/*  */}
        <div className="flex flex-col">
          {/* Tab Navigation */}
          <div className="flex items-center justify-between text-lg font-semibold gap-4 mt-4">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setActiveTab("details")}
                className={
                  activeTab === "details"
                    ? "text-[#FF0000] font-semibold underline decoration-[#FF0000] underline-offset-4"
                    : "text-gray-500 hover:text-[#FF0000]"
                }
              >
                Product Details
              </button>
              <button
                onClick={() => setActiveTab("owner")}
                className={
                  activeTab === "owner"
                    ? "text-[#FF0000] font-semibold underline decoration-[#FF0000] underline-offset-4"
                    : "text-gray-500 hover:text-[#FF0000]"
                }
              >
                Product Owner Details
              </button>
            </div>

            <div>
              <StatusDropdown />
            </div>
          </div>

          {/* Tab Content */}
          <div className="mt-6 ">
            {activeTab === "details" && (
              <Product_Details button={"show"} setActiveTab={setActiveTab} />
            )}
            {activeTab === "owner" && (
              <div className="w-full">
                <Product_Owner_Edit_Form />
              </div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="fixed  inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-72 gap-4 flex flex-col  py-5 text-center relative">
            <div className="flex w-full justify-center">
              <AiFillQuestionCircle className="text-6xl text-red-700 text-center" />
            </div>
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-md font-semibold">
                Do you want to delete this buyer contact ?
              </h3>
            </div>

            <div className="flex justify-center gap-5  ">
              <button
                onClick={() => setShowModal(false)}
                className="border border-b-teal-950 cousor-pointer text-red-700 px-4 py-1 rounded"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setShowModalSave(true);
                  setShowModal(false);
                }}
                className="bg-red-700  text-white px-4 py-1 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Modal */}
      {showModalSave && (
        <div className="fixed  inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-72 gap-4 flex flex-col  py-5 text-center relative">
            <div className="flex w-full justify-center">
              <FaCheckCircle className="text-6xl text-red-700 text-center" />
            </div>
            <div className="flex justify-center items-center mb-2">
              <h3 className="text-md text-center font-semibold">
               Contact Deleted Successfully !!!!
              </h3>
            </div>

            <div className="flex justify-center gap-5  ">
              <button
                onClick={() => handleSubmit()}
                className="bg-red-700  text-white px-4 py-1 rounded"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Add_Produc_Edit;
